export default "__VITE_ASSET__CJqRbAO7__"